<template>
  <boolean-field
    :disabled="disabled"
    :label="trans(`aspects.${aspect}.common.yes`)"
    :name="name"
    :value="value"
    @update:data="(checked) => $emit('update:data', checked)"
  >
  </boolean-field>
</template>

<script>
import BooleanField from './Boolean';

export default {
  components: {
    BooleanField,
  },
  props: {
    disabled: { type: Boolean, default: () => false },
    name: { type: String, default: () => '' },
    label: { type: String, default: () => '' },
    value: { type: String, default: '' },
  },
  emits: ['update:data'],
  setup() {
    return {};
  },
};
</script>
